import { Typography } from '@mui/material';
import { InfoAlert } from 'components/alert/InfoAlert';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

function Bold(chunks: React.ReactNode) {
  return <strong>{chunks}</strong>;
}

export function DrilldownPagesInfoContent() {
  return (
    <div>
      <InfoAlert messageId="trading.info.alert" values={{ disclaimer: 'Disclaimer:', b: Bold }} />

      <Typography variant="body1" sx={{ fontWeight: 400, mb: 3 }}>
        <FormattedMessage id="info.content.helpful_information" defaultMessage="Helpful information" />
      </Typography>

      <InfoContentItem
        titleId="info.content.why_is_this_view_useful"
        descriptionId="steeringhub.insightsfeed.info.drilldown.why_is_this_view_useful.description"
      />

      <hr className="my-4 border-snow-200" />

      <Typography variant="body1" sx={{ mb: 3, fontWeight: 400 }}>
        <FormattedMessage id="info.content.kpis" defaultMessage="Key Performance Indicators (KPIs)" />
      </Typography>

      <InfoContentItem
        titleId="trading.drilldown.column.delta.day.lastweek"
        descriptionId="steeringhub.insightsfeed.info.drilldown.kpi.delta_same_weekday_last_week.description"
      />
      <InfoContentItem
        titleId="trading.drilldown.column.delta.fourWeekAvg"
        descriptionId="steeringhub.insightsfeed.info.drilldown.kpi.delta_avg_same_weekday_last_four_weeks.description"
      />
      <InfoContentItem
        titleId="trading.drilldown.column.delta.week.lastweek"
        descriptionId="steeringhub.insightsfeed.info.drilldown.kpi.delta_last_7_days_wow.description"
      />
      <InfoContentItem
        titleId="insights.measure.omsOrdDmvVal.name"
        descriptionId="model.metric.ordGmvVal.description"
      />
      <InfoContentItem titleId="insights.measure.omsOrdQty.name" descriptionId="model.metric.ordQty.description" />
      <InfoContentItem
        titleId="insights.measure.omsAvgOrdDmvVal.name"
        descriptionId="model.metric.avgOrdGmvVal.description"
      />
      <InfoContentItem titleId="insights.measure.omsOrdNum.name" descriptionId="model.metric.ordNum.description" />
      <InfoContentItem
        titleId="trading.drilldown.column.share"
        descriptionId="steeringhub.insightsfeed.info.drilldown.kpi.share.description"
      />

      <hr className="my-4 border-snow-200" />

      <InfoContentItem
        titleId="steeringhub.insightsfeed.info.beta.title"
        descriptionId="steeringhub.insightsfeed.info.beta.description"
      />
    </div>
  );
}
